import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRoutes } from "../../../utils/ApiRoutes";
import { cancelSubscriptionApi, getIntercomTokenApi, getUserProfileApi, updateUserProfileApi, uploadProfilePictureApi, requestDeleteAccountApi, confirmDeleteAccountApi } from "../../apis";
import { ICancelSubscriptionData } from "../../apis/IApisInterface";
import { showSnackbar } from "../../slices/SnackbarSlice";
import { checkinDashboardApi, trackerDashboardApi } from "../../apis/UserApis/DashboardApi";

const USER_PROFILE = apiRoutes?.userProfile
const CANCEL_SUBSCRIPTION = apiRoutes?.cancelSubscription


export const getUserProfileAction = createAsyncThunk(USER_PROFILE, async ( _, { rejectWithValue }) => {
    try {
        const response = await getUserProfileApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get user profile" })
    }
})

export const cancelSubscriptionAction = createAsyncThunk(CANCEL_SUBSCRIPTION, async ( id : ICancelSubscriptionData, { rejectWithValue, dispatch }) => {
    try {
        const response = await cancelSubscriptionApi(id)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Cancel subscription failed" });
    }
})

export const trackerDashboardAction = createAsyncThunk("tracker_dashboard", async ( payload : {page:number ,search?:string , limit:number, sort_by?: string, sort_order?: string}, { rejectWithValue, dispatch }) => {
    try {
        const response = await trackerDashboardApi(payload)
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Cancel subscription failed" });
    }
})
export const checkinDashboardAction = createAsyncThunk("checkin_dashboard", async ( payload : {page:number ,search?:string , limit:number, sort_by?: string, sort_order?: string}, { rejectWithValue, dispatch }) => {
    try {
        const response = await checkinDashboardApi(payload)
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Cancel subscription failed" });
    }
})

export const updateUserProfileAction = createAsyncThunk("update_user_profile", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateUserProfileApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message || "Profile updated successfully", type: "success" }));
        dispatch(getUserProfileAction());
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "Profile update failed", type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Profile update failed" });
    }
})

export const uploadProfilePictureAction = createAsyncThunk("upload_profile_picture", async (file: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await uploadProfilePictureApi(file);
        dispatch(showSnackbar({ message: response?.data?.message || "Profile picture uploaded successfully", type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "Profile picture upload failed", type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Profile picture upload failed" });
    }
});

export const getIntercomTokenAction = createAsyncThunk("intercom_token", async (_, { rejectWithValue }) => {
    try {
        const response = await getIntercomTokenApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get intercom token" })
    }
})

export const requestDeleteAccountAction = createAsyncThunk(
    "request_delete_account",
    async (_, { rejectWithValue }) => {
        try {
            const response = await requestDeleteAccountApi();
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data || { message: "Could not request account deletion" });
        }
    }
);

export const confirmDeleteAccountAction = createAsyncThunk(
    "confirm_delete_account",
    async (payload: { otp: string }, { rejectWithValue }) => {
        try {
            const response = await confirmDeleteAccountApi(payload);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.response?.data || { message: "Invalid or expired verification code" });
        }
    }
);